import React from "react";
import Input from "../Input";
const AntSearch = Input.Search;

export default function Search({
  field,
  value,
  placeholder,
  onChange,
  opts = {},
  disabled
}) {
  return (
    <AntSearch
      name={field}
      value={value}
      placeholder={placeholder || "请输入"}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      enterButton={opts.enterButton}
      {...opts}
    />
  );
}
